import React from 'react'
import styled from 'particles/themes/styled'
import Icon from 'components/Icon/Icon'
import { useNewTranslation } from 'hooks/index'
import Button from 'components/Shared/Button/Button'
import { theme } from 'theme'

interface SmallScreenPopper {
    className?: string
    title?: string
    description?: string
    setShow: () => void
}

const SmallScreenPopper: React.FC<SmallScreenPopper> = ({ className, title, description, setShow }) => {
    const [newT] = useNewTranslation()

    return (
        <div className={className}>
            <div className="popup-content">
                <div className="icon">
                    <Icon.CloseIcon style={{ fill: theme.newColors.neutral400 }} onClick={setShow} />
                </div>
                <div className="title">{title && title}</div>
                <div className="description">{description && description}</div>
                <Button
                    size="l"
                    customStyle={{ width: '100%' }}
                    buttonType="primary"
                    onClick={setShow}
                    text={newT('button.gotIt')}
                />
            </div>
        </div>
    )
}

export default styled(SmallScreenPopper)`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: calc(100% - env(safe-area-inset-bottom));
    background-color: rgba(1, 1, 1, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    .popup-content {
        width: 100%;
        min-height: 209px;
        height: fit-content;
        box-sizing: border-box;
        padding: 16px 16px ${theme.gutter.s};
        background-color: ${theme.newColors.neutral50};
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 16px;
        .icon {
            display: flex;
            justify-content: flex-end;
            cursor: pointer;
        }
        .title {
            font-weight: ${theme.fontWeight.bold};
            line-height: 24px;
            color: ${theme.newColors.neutral700};
        }
        .description {
            font-weight: 400;
            line-height: 24px;
            color: ${theme.newColors.neutral500};
        }
    }
`
